/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { TranslationService } from '@gh/core-mls';
import { ManualGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';
import { getLetterTemplateId } from '../../resources/letter-template.model';

@Injectable()
export class LetterTemplateGridDefinition extends ManualGridDefinition {

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'fileName',
      headerName: this.translationService.get('lbl_file_name'),
      resizable: false,
    }];
  }

  buildGridOptions(): GridOptions {
    return { rowSelection: 'single', getRowNodeId: getLetterTemplateId };
  }
}
